import { apiClient } from '@/shared/lib/apiClient';
import type { ApiResponse, User } from '@/types';

export interface UpdateContactPayload {
  displayName: string;
  contactPhone: string;
  email?: string;
  emergencyContactName?: string | null;
  emergencyContactNumber?: string | null;
}

export interface UpdateEmergencyContactPayload {
  emergencyContactName?: string | null;
  emergencyContactNumber?: string | null;
}

export interface UpdateProfilePayload {
  firstName?: string;
  lastName?: string;
  country?: string;
}

export const userApi = {
  async getProfile() {
    const response = await apiClient.get<ApiResponse<User>>('/users/me');
    return response.data.data!;
  },

  async updateProfile(payload: UpdateProfilePayload) {
    const response = await apiClient.patch<ApiResponse<User>>('/users/me', payload);
    return response.data.data!;
  },

  async completeProfile(payload: { firstName: string; lastName: string; email: string }) {
    const response = await apiClient.post<ApiResponse<import('@/types').MeResponse>>(
      '/users/me/complete-profile',
      payload
    );
    return response.data.data!;
  },

  async updateContact(payload: UpdateContactPayload) {
    const response = await apiClient.patch<ApiResponse<User>>('/users/me/contact', payload);
    return response.data.data!;
  },

  async updateEmergencyContact(payload: UpdateEmergencyContactPayload) {
    const response = await apiClient.patch<ApiResponse<User>>(
      '/users/me/emergency-contact',
      payload
    );
    return response.data.data!;
  },

  async uploadAvatar(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post<ApiResponse<User>>('/users/me/avatar', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data.data!;
  },
};
